module.exports = __webpack_public_path__ + "static/academyBanner-d909302a36fe75e9f10b29c735640fee.png";